// extracted by mini-css-extract-plugin
export default {"wrapper":"MyBtn_wrapper__mbwgh","btn":"MyBtn_btn__LBGHg","border":"MyBtn_border__HFjHY"};